import { all, AllEffect, ForkEffect, put, takeLatest } from 'redux-saga/effects'
import { showPlanLimitsPopup } from './actions'
import { planLimitsTypes } from './actionTypes'
import { handlePlanLimitsPopupErrorRequest } from './types'

function* handlePlanLimitsPopupError(
    action: handlePlanLimitsPopupErrorRequest,
) {
    const { message } = action.payload
    if (message.includes('SubscriptionLimitsExceededException')) {
        yield put(showPlanLimitsPopup())
    }
}

function* handlePlanLimitsPopupErrorSaga(): Generator<
    AllEffect<ForkEffect<never>>,
    void,
    unknown
> {
    yield all([
        takeLatest(
            planLimitsTypes.HANDLE_PLAN_LIMIT_POPUP_ERROR,
            handlePlanLimitsPopupError,
        ),
    ])
}

export default handlePlanLimitsPopupErrorSaga
